<template>
    <div class="d-flex align-items-center">
        <b-media no-body class="mr-2 d-flex align-items-center">
            <b-media-aside>
                <b-avatar :to="{ path: '/ReminderReport' }" size="36" variant="light-primary">
                    <feather-icon size="24" icon="BellIcon" />
                </b-avatar>
            </b-media-aside>
            <b-media-body class="d-flex align-items-center">
                <h6 class="font-weight-bolder mb-0 ">
                    {{ reminderCount }} - 
                </h6>
                <b-card-text class="mb-0" style="font-size: 0.9rem; white-space: nowrap;">
                    {{ $t('dashboard.reminder_count') }}
                </b-card-text>
            </b-media-body>
        </b-media>

        <b-media no-body class="d-flex align-items-center">
            <b-media-aside>
                <b-avatar :to="{ path: '/DailyworkReport', query: { billingStatusId: 1 } }" size="36" variant="light-danger">
                    <feather-icon size="24" icon="BriefcaseIcon" />
                </b-avatar>
            </b-media-aside>
            <b-media-body class="d-flex align-items-center">
                <h6 class="font-weight-bolder mb-0 ">
                    {{ activeDailyworkCountForUser }} - 
                </h6>
                <b-card-text class="mb-0" style="font-size: 0.9rem; white-space: nowrap;">
                    {{ $t('dashboard.dailywork') }}
                </b-card-text>
            </b-media-body>
        </b-media>
    </div>
</template>
<script>
export default {
    data() {
        return {
            reminderCount: 0,
            activeDailyworkCountForUser: 0,
        }
    },
    beforeMount() {
        this.getDashboardDailywork()
    },
    methods: {
        getDashboardDailywork(){
            const data = {
            id: localStorage.getItem('EmployeeId')
        }
        const controller = {
            name: 'Dashboard'
        }
        const payload = {
            data: data,
            controller: controller
        }
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
            if (response.data.resultStatus == true) {
                this.reminderCount = response.data.dashboard.reminderCount
                this.activeDailyworkCountForUser = response.data.dashboard.activeDailyworkCountForUser
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        })
        }
    }
}
</script>